/**
 * Знак итога (ТЗ UI-69).
 *
 * Измерительная шкала с отметкой: она говорит «измерено», а не «отлично».
 * Своей цифры в ней нет намеренно — цифра стоит рядом в тексте, и две копии
 * одного числа рано или поздно разойдутся.
 *
 * Успешный вид берётся только там, где успех действительно есть: у
 * контрольного теста он приходит вердиктом сервера. Обычное занятие успехом не
 * заканчивается — оно просто заканчивается, и знак у него спокойный.
 *
 * Знак декоративен: смысл итога стоит словами рядом, и повторять его голосом
 * незачем. Без картинки текст остаётся полным.
 */

export type ResultTone = 'neutral' | 'success';

export interface ResultMarkProps {
  /** Спокойный знак завершения или знак подтверждённого успеха. */
  readonly tone?: ResultTone;
}

export function ResultMark({ tone = 'neutral' }: ResultMarkProps): React.JSX.Element {
  return (
    <svg
      className={`t2x-result-mark t2x-result-mark--${tone}`}
      viewBox="0 0 64 40"
      width="64"
      height="40"
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      {/* Дуга шкалы: то, по чему измеряют. */}
      <path
        d="M6 34 A26 26 0 0 1 58 34"
        fill="none"
        stroke="var(--t2x-border-strong)"
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* Деления: три, чтобы дуга читалась шкалой, а не просто скобкой. */}
      <g stroke="var(--t2x-border-strong)" strokeWidth="2" strokeLinecap="round">
        <path d="M10 26 l4 -2" />
        <path d="M32 8 v4" />
        <path d="M54 26 l-4 -2" />
      </g>

      {/* Отметка: у спокойного знака — стрелка шкалы, у успеха — галочка. */}
      {tone === 'neutral' ? (
        <path
          d="M32 34 L44 18"
          stroke="var(--t2x-accent)"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
        />
      ) : (
        <path
          d="M22 26 l7 7 14 -17"
          stroke="var(--t2x-success)"
          strokeWidth="4"
          strokeLinecap="square"
          fill="none"
        />
      )}
    </svg>
  );
}
